/**
 *
 * @page 用户中心/账户设置/修改密码
 *
 **/

import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import ChangePasswordContent from '&/components/ChangePassword';

function ChangePassword() {
    return (
        <BasePageWrap
            type="card"
            className="change-password"
            title={intl.get('accountSetting.changePassword')}>
            <ChangePasswordContent />
        </BasePageWrap>
    );
}

export default ChangePassword;
